import React, { useState } from 'react';
import { Modal, Box, Button, TextField, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AddGroupModal = ({ open, handleClose, handleSubmit }) => {
  const [groupName, setGroupName] = useState('');

  const handleModalSubmit = () => {
    handleSubmit(groupName);
    setGroupName('');
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        width: 300,
        borderRadius: 2,
        outline: 'none',
      }}>
        <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <h3>Add Group</h3>
        <hr></hr>
        <TextField
          variant="outlined"
          placeholder="Group Name"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          fullWidth
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              height: 40,
              backgroundColor: 'white'
            },
            '& .MuiOutlinedInput-input': {
              height: 40,
              width: '100%',
            },
          }}
        />
        
        <Button
          onClick={handleModalSubmit}
          fullWidth
          sx={{
            mt: 2,
            backgroundColor: 'var(--button-color)',
            color: 'white',
            ':hover': { backgroundColor: 'var(--button-hover-color)' },
          }}
        >
          Submit
        </Button>
        <Button
          variant="outlined"
          onClick={handleClose}
          fullWidth
          sx={{
            mt: 2,
            borderColor: 'var(--button-color)',
            color: 'var(--button-color)',
            ':hover': { borderColor: 'var(--button-hover-color)' },
          }}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
};

export default AddGroupModal;